import { render } from "./Facts.vue?vue&type=template&id=d3bf812c&scoped=true"
import script from "./Facts.vue?vue&type=script&lang=js"
export * from "./Facts.vue?vue&type=script&lang=js"

import "./Facts.vue?vue&type=style&index=0&id=d3bf812c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3182697143/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3bf812c"]])

export default __exports__